import store from "@/store";
import { Ticket } from "leatherman-js/models";

const handler = (event, data) => {
  switch (event) {
    case "ticket:update":
      store.dispatch("tickets/updateTicket", new Ticket(data));
  }
};

export default handler;
